export const SOCIAL_HANDLE_PREFIX = {
  instagram: 'https://instagram.com/',
  tiktok: 'https://tiktok.com/@'
} as const

export type HandleSocialId = keyof typeof SOCIAL_HANDLE_PREFIX

export const SOCIAL_HANDLE_LABEL: Record<HandleSocialId, string> = {
  instagram: 'instagram.com/',
  tiktok: 'tiktok.com/@'
}

const HANDLE_PATTERN = /^[A-Za-z0-9._]+$/

const HOSTS: Record<HandleSocialId, RegExp> = {
  instagram: /^(?:https?:\/\/)?(?:www\.)?instagram\.com\/@?/i,
  tiktok: /^(?:https?:\/\/)?(?:www\.)?tiktok\.com\/@?/i
}

export const isHandleSocial = (id: string): id is HandleSocialId => id in SOCIAL_HANDLE_PREFIX

export const handleFromUrl = (id: HandleSocialId, value: string | null | undefined): string =>
  (value ?? '')
    .trim()
    .replace(HOSTS[id], '')
    .replace(/^@/, '')
    .replace(/[/?#].*$/, '')

export const urlFromHandle = (id: HandleSocialId, input: string): string => {
  const handle = handleFromUrl(id, input).replace(/\s+/g, '')

  return handle ? `${SOCIAL_HANDLE_PREFIX[id]}${handle}` : ''
}

export const isInvalidHandle = (id: HandleSocialId, value: string | null | undefined): boolean => {
  const handle = handleFromUrl(id, value)

  return handle.length > 0 && !HANDLE_PATTERN.test(handle)
}
